import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const ProductDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'product',
        routeParamKey: 'productId',
        pageTitle: 'Product Details',
        backRoute: '/products',
        backLabel: 'Back to Products',
        tabIdPrefix: 'product',
        tabsAriaLabel: 'product detail tabs',
        missingIdMessage: 'No product ID provided in the URL.',
        noDataMessage: 'No product data available. The product might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default ProductDetailPage;
